// extracted by extract-css-chunks-webpack-plugin
module.exports = {"cover-lots-wide":"cover-lots-wide___3PB78","img-container":"img-container___JdhIa","primary":"primary___1jA55","blurry":"blurry___3WP_N"};